import { useCallback, useEffect, useState } from "react";
import { MAX_RETRIES } from "../../configs/configs";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";
import useRetry from "../Common/useRetry";

function useGetMerchantSST() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [sstInfo, setSSTInfo] = useState({});
  const { retryCount, setRetryCount } = useRetry(
    () => getMerchantSST(),
    MAX_RETRIES
  );

  const getMerchantSST = useCallback(() => {
    fetchWrapper({
      endpoint_url: "merchant/getMerchantSST",
      method: "GET",
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          setSSTInfo(data);
          setRetryCount(0);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "fetch",
            message: "Get Merchant SST",
            extra: "Retrying...",
          });

        setRetryCount((prev) => prev + 1);
      },
      onResponseError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "response",
            message: "Get Merchant SST",
            extra: "Retrying...",
          });

        setRetryCount((prev) => prev + 1);
      },
    });
  }, [fetchWrapper]);

  useEffect(() => {
    getMerchantSST();
  }, []);

  return { sstInfo, getMerchantSST };
}

export default useGetMerchantSST;
